import moment from "moment";
import {
  calcKcalByAttrId,
  emptyMealStudyDrug,
} from "../../../../helpers/mealsHelper";
import {
  dailyTargetIds,
  DateFormat,
  getBaseDateFormat,
} from "../../../../modules/constants";
import { DIET_DIARY_TYPE_NAME } from "../../../smart/DietDiary/DietDiary.constants";

export const calcStudyDrugPercentage = (studyDrugDaiy, totalCalories) => {
  const studyDrugKcal = calcKcalByAttrId(
    studyDrugDaiy,
    dailyTargetIds.MEDIUM_CHAIN_FATS_ATTR_ID
  );
  let totalPercentage = 0;
  if (!!studyDrugKcal && !!totalCalories) {
    totalPercentage = (studyDrugKcal * 100) / totalCalories;
  }
  return totalPercentage;
};

const aggregatorByDay = (accumulator, item) => {
  return {
    date: `${item?.date}`,
    studyDrugQty: (accumulator?.studyDrugQty || 0) + item.studyDrugQty,
    completed: item?.completed,
    sickDay: item?.sickDay,
    dayTotal: true,
  };
};

const aggregateByDay = (data) => {
  const dataByDay = data
    .filter((meal) => meal.date === data[data.length - 1].date)
    .reduce(aggregatorByDay, {});

  return dataByDay;
};

const setHideMeal = (item) => {
  if (item?.hideMeal === true) {
    return true;
  }
  if (item?.title === DIET_DIARY_TYPE_NAME.STUDY_DRUG) {
    return false;
  }
  return true;
};

const calcTotalAverage = (data) => {
  const totalRangeNutrients = data
    .filter((key) => key.dayTotal)
    .map((item) => item.studyDrugQty)
    .reduce((a, b) => a + b, 0);
  const nDays = data.filter((key) => key.dayTotal).length;
  return totalRangeNutrients / nDays;
};

const isEmpty = (obj) => {
  return !!(Object.keys(obj[0]).length === 0);
};

export const getDataToStudyDrugIntakeReport = (entries, allDates) => {
  let totalsData = { completedDays: 0, sickDays: 0, average: 0 };
  let itemId = 0;
  const mealData = [];

  entries?.forEach((dailyEntry) => {
    const { date, completed, sickDay } = dailyEntry;

    if (completed) totalsData.completedDays += 1;
    if (sickDay) totalsData.sickDays += 1;

    if ((sickDay || completed) && !dailyEntry.meals.length) {
      dailyEntry.meals.push({
        mealJson: emptyMealStudyDrug,
      });
    }

    dailyEntry.meals.forEach((meal) => {
      const mealParsed = JSON.parse(meal.mealJson);
      mealParsed.items.forEach((item) => {
        itemId++;
        const mealDate = moment(date).format(getBaseDateFormat());

        if (
          mealData.length > 0 &&
          mealData[mealData.length - 1].date !== mealDate
        ) {
          mealData.push(aggregateByDay(mealData));
        }

        const newItem = {
          itemId,
          date: mealDate,
          extendedDate: moment(meal?.mealDate || date).format(
            DateFormat.EXTENDED_DATETIME
          ),
          hour: moment(meal?.mealDate).format(DateFormat.HOUR),
          completed: completed ? "Yes" : "No",
          sickDay: sickDay ? "Yes" : "No",
          studyDrugQty:
            item?.title === DIET_DIARY_TYPE_NAME.STUDY_DRUG &&
            Number(item?.qty || 0),
          hideMeal: setHideMeal(item),
        };
        mealData.push(newItem);
      });
    });
  });
  mealData.push(aggregateByDay(mealData));

  const emptyData = [];
  let dateRangeData;

  allDates.forEach(function (date) {
    const emptyDayData = {
      completed: "No",
      sickDay: "No",
      studyDrugQty: 0,
      date: moment(date).format(getBaseDateFormat()),
      dayTotal: true,
      extendedDate: moment(date).format(DateFormat.EXTENDED_DATETIME),
    };
    emptyData.push(emptyDayData);
  });

  if (!isEmpty(mealData)) {
    dateRangeData = Object.values(
      [].concat(emptyData, mealData).reduce((r, c) => {
        if (c.dayTotal) {
          r[c.date] = Object.assign(r[c.date] || {}, c);
        } else {
          r[c.itemId] = Object.assign(r[c.itemId] || {}, c);
        }
        return r;
      }, {})
    );
  } else {
    dateRangeData = emptyData;
  }

  dateRangeData.sort(
    (a, b) =>
      moment(a.extendedDate, DateFormat.EXTENDED_DATETIME).diff(
        moment(b.extendedDate, DateFormat.EXTENDED_DATETIME)
      ) || b.studyDrugQty - a.studyDrugQty
  );

  dateRangeData = dateRangeData.filter((data) => !data.hideMeal);
  totalsData.average = calcTotalAverage(dateRangeData);

  return { dateRangeData, totalsData };
};
